import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { useDispatch, useSelector } from 'react-redux';
import StoreList from '../../components/StoreList';
import Title from '../../components/Title';
import StoreListItem from '../../components/StoreListItem';
import { MIN_DISTANCE_TO_STORE } from '../../constants/stores';
import { filterStores } from '../../store/slices/storesSlice';
import { StoreCategory, StoreProductVersion, StoreService } from '../../types/store';
import { hideClosestStoreMarker, showClosestStoreMarker } from '../../store/slices/uiSlice';
import { getClosestIqosStore, getFilteredStores } from '../../store/selectors/storesSelectors';
import { getPaths } from '../../utils/element';
const BuyLilSolidEz = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const minDistanceToStore = MIN_DISTANCE_TO_STORE;
    const stores = useSelector(getFilteredStores);
    const closestIqosStore = useSelector(getClosestIqosStore);
    const sellingProductVersionsString = useMemo(() => {
        return [StoreProductVersion.VersionLilSolidEz]
            .filter(productVersion => stores.some(store => store.category !== StoreCategory.Iqos && store.sellingProductVersions?.indexOf(productVersion) !== -1))
            .map(version => t(`store_locator.product_versions.${version}`))
            .join(', ');
    }, [stores]);
    useEffect(() => {
        dispatch(filterStores({
            services: [StoreService.Sale],
            productVersion: [StoreProductVersion.VersionLilSolidEz],
        }));
        dispatch(showClosestStoreMarker());
        return () => {
            dispatch(filterStores({}));
            dispatch(hideClosestStoreMarker());
        };
    }, []);
    return (_jsx("div", { children: _jsx(StoreList, { headerComponent: _jsxs(_Fragment, { children: [_jsx(Title, { title: t('store_locator.buy-lil-solid-ez.title'), viewInMap: true }), sellingProductVersionsString && (_jsxs("div", { className: "mb-4", children: [_jsx("div", { className: "font-size-large font-weight-bold mb-2", children: t('store_locator.buy-iqos.buying_at_partners.title') }), _jsx("ul", { className: "font-size-small mb-4", children: _jsx("li", { className: "mb-2", children: parse(t('store_locator.buy-iqos.buying_at_partners.list_item_1', {
                                        products: sellingProductVersionsString,
                                        class: 'link-underlined',
                                        href: getPaths().sylius_shop_lil_solid_ez_products_index,
                                    })) }) }), _jsx("a", { target: "_blank", rel: "noreferrer", href: getPaths().sylius_shop_lil_solid_ez_products_index, className: "btn btn-outline-dark", children: t('store_locator.buy-iqos.ecommerce') })] }))] }), footerComponent: _jsx("div", { className: "map-content-inner-no-gutters", children: closestIqosStore && (closestIqosStore.distanceToPosition || 0) > minDistanceToStore && (_jsx("div", { className: "list-group list-group-padless list-group-padded-md", children: _jsx(StoreListItem, { source: closestIqosStore }) })) }) }) }));
};
export default BuyLilSolidEz;
